export const APP_ROLES = {
  ADMIN: 'administrator',
  OPERATOR: 'operator',
  ANALYST: 'analyst',
  VIEWER: 'viewer',
} as const;

export type AppRole = typeof APP_ROLES[keyof typeof APP_ROLES];
